import { css } from '@emotion/core';
import { colorsPalette } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';
import { typography } from '../../../../../styles/typography';

export const filterColumn = css({
  [MediaQueries.sm]: {
    boxSizing: 'content-box',
    position: 'absolute',
    right: 0,
    top: 0,
    width: 56,
  },
});

export const filter = css(typography.effra18, {
  alignItems: 'baseline',
  color: colorsPalette.dark,
  display: 'flex',
  fontSize: 18,
  justifyContent: 'space-between',
  letterSpacing: 0,
  marginTop: 1,
  outline: `1px solid ${colorsPalette.grey20}`,
  padding: '11px 16px 10px',
  textAlign: 'left',
  textTransform: 'none',

  [MediaQueries.sm]: {
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 'auto',
    padding: 0,
    width: ' 100%',
  },
  [MediaQueries.lgAndUp]: {
    padding: '11px 24px 10px',
  },
});

export const iconFilter = css({
  fontSize: 17,
});

export const clearButton = css({
  background: 'none',
  border: 'none',
  color: colorsPalette.grey60,
  height: '100%',
});

export const selectedFilters = css({
  marginLeft: 2,
});

export const filterText = filterText =>
  css({
    color: filterText ? colorsPalette.black : colorsPalette.grey80,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    [MediaQueries.sm]: {
      display: 'none',
    },
  });

export const clearText = css(typography.effra16, {
  position: 'relative',
  '&:after': {
    position: 'absolute',
    bottom: -4,
    width: '100%',
    content: '" "',
    left: 0,
    borderBottom: `1px solid ${colorsPalette.grey20}`,
  },
});

export const selectLabel = css({
  minHeight: 55,
  padding: '18px 16px 3px',
});
